export const ELEMENT_NAME_MIN = 1;
export const ELEMENT_NAME_MAX = 100;

export const MIN_QUESTION_LENGTH = 1;
export const MAX_QUESTION_LENGTH = 500;

export const MIN_LIKERT_SCALE_LENGTH = 1;
export const MAX_LIKERT_SCALE_LENGTH = 30;
export const MIN_LIKERT_QUESTION_LENGTH = 1;
export const MAX_LIKERT_QUESTION_LENGTH = 200;

export const MIN_ANSWER_LENGTH = 1;
export const MAX_ANSWER_LENGTH = 500;
export const MAX_MATCH_PAIR_LENGTH = 75;
export const MAX_MATCH_PAIR_COMMENT_LENGTH = 150;

export const MAX_COMMENT_LENGTH = 500;

export const TRY_BUTTON_MIN = 1;
export const TRY_BUTTON_MAX = 100;

export const BUTTON_MIN = 1;
export const BUTTON_MAX = 100;

export const FORM_TITLE_MIN = 1;
export const FORM_TITLE_MAX = 200;

export const HTML_MIN = 1;

export const LIST_ITEM_MIN = 1;
export const LIST_ITEM_MAX = 800;

export const STATIC_TEXT_MAX = 1500;

export const TEXT_INPUT_LABEL_MIN = 1;
export const TEXT_INPUT_LABEL_MAX = 100;
export const TEXT_INPUT_PLACEHOLDER_MIN = 1;
export const TEXT_INPUT_PLACEHOLDER_MAX = 100;
export const TEXT_INPUT_REGEX_MAX = 200;
export const TEXT_INPUT_REGEX_MESSAGE_MAX = 100;
export const FORM_FIELD_ELEMENT_NAME_MAX = 100;
